var module = angular.module('octopusApp.projects');

module.directive('deployButtons', function(busy, octopusRepository, octopusPermissionSet, $q) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    templateUrl: 'areas/projects/views/deploy_buttons.html',
    scope: {
      project: '=',
      release: '=',
      lifecycle: '=',
      environments: '=',
      progression: '='
    },
    link: function(scope, element, attrs) {
      scope.filterEnvironments = function () {
        var allowedEnvironments = {};

        var checks = _.map(scope.environments, function(environment){
          return octopusPermissionSet.isAuthorized({
            permission: "DeploymentCreate",
            projectId: scope.project && scope.project.Id,
            environmentId: environment.Id
          }).then(function(allowed){
            if(allowed){
              allowedEnvironments[environment.Id] = environment;
            }
          });
        });

        $q.all(checks).then(function(){
          scope.environmentsById = allowedEnvironments;
        });
      };

      scope.environmentsById = {};
      scope.$watch("environments", scope.filterEnvironments);
      scope.$watch("project", scope.filterEnvironments);

      scope.customClasses = attrs.class;
      scope.deployOrPromote = "Deploy";

      scope.$watch("progression", function() {
        scope.deployed = {};
        scope.tasks = {};
        scope.warning = {};
        scope.progress = {};

        if (!scope.progression) {
          return;
        }

        var deploymentCount = 0;

        scope.nextDeployments = _.filter(scope.progression.NextDeployments, function(en){ return scope.environmentsById[en]; } );
        scope.nextDeploymentsCombined = scope.nextDeployments.join(',');

        _.each(scope.progression.Phases, function (phase) {
          scope.progress[phase.Name] = phase.Progress;
          _.each(phase.Deployments, function (deployment) {
            deploymentCount++;
            scope.deployed[deployment.Deployment.EnvironmentId] = true;
            scope.tasks[deployment.Deployment.EnvironmentId] = deployment.Task.Id;
            scope.warning[deployment.Deployment.EnvironmentId] = deployment.Task.HasWarningsOrErrors;
          });
        });

        scope.deployOrPromote = (deploymentCount > 0) ? "Promote" : "Deploy";
      });

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/deploy_buttons.js
// module id = 662809420561366
// module chunks = 1